import { Action, Error, EventName, Method, NO_VALUE, pageLoginSources, } from './constants.js';
export const buildFormFieldErrorPayload = (formFieldErrorParams) => {
    const { componentTitle, formFieldErrors, loginSource, componentState } = formFieldErrorParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: componentTitle,
            linkName: `${Error.FORM_FIELD}Error`,
        },
        trackingData: {
            componentName: componentTitle,
            componentState: NO_VALUE,
            formFieldErrors: formFieldErrors,
            loginSource: loginSource,
            allowLinkBeforeView: true,
            elementActionValue: NO_VALUE,
            eventName: EventName.ERROR,
            elementActioned: Error.FORM_FIELD,
            elementAction: Action.ERROR,
            ...(componentState && { componentState }),
        },
    };
    if (!pageLoginSources.includes(loginSource)) {
        delete trackingPayload.trackingData.componentName;
    }
    return trackingPayload;
};
//# sourceMappingURL=buildFormFieldErrorPayload.js.map